import TopMenu from "../../TopMenu";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { get } from "../../../../utils/api";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import TableDocument from "../../TableDocument";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";

const Main = () => {
  const { user } = useUser();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("/naturalGasDoc");
  const columnWidth = user?.companyAdmin
    ? "12% 15% 15% 15% 15% 17% 8%"
    : "12% 18% 20% 18% 18% 8%";
  const toggleData = [
    { title: "Natural Gas", url: "/naturalGasDoc" },
    { title: "Coal", url: "/coalDoc" },
    { title: "Petroleum / Gasoline", url: "/petrolOrGasolineDoc" },
    { title: "Diesel", url: "/diselDoc" },
    { title: "Fuel Oil", url: "/fuelDoc" },
    { title: "LPG", url: "/lpgDoc" },
    { title: "Propane", url: "/propaneDoc" },
  ];

  const headers = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Industrial Process",
      key: "industrialProcess",
      field: "industryProcess",
    },
    {
      title: "Equipment Type",
      key: "equipmentType",
    },
    {
      title: "Equipment",
      key: "industrialEquipment",
    },
  ].filter(Boolean);

  const [data, setData] = useState([]);
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Equipment Type": false,
    Equipment: false,
  });
  const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    equipmentType: [],
    industrialEquipment: [],
  });
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [searchQuery, setSearchQuery] = useState("");

  const filters = ["Date", "Equipment Type", "Equipment"];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/stationaryCombustion${url}`);
      const data = response.data.data;

      const uniqueEquipmentType = [
        ...new Set(
          data.map((el) => el.equipmentType?.name).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueIndustrialEquipment = [
        ...new Set(
          data.map((el) => el.industrialEquipment?.name).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        equipmentType: uniqueEquipmentType,
        industrialEquipment: uniqueIndustrialEquipment,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        facilityList: selectedFacility.join(","),
        limit: rowsPerPage,
        search: searchQuery,
      }).toString();
      const response = await get(
        `/stationaryCombustion${url}?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, searchQuery, url, fromDate, toDate, selectedFacility]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
    endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
    ...Object.keys(selectedFields).reduce((acc, key) => {
      const selectedOptions = selectedFields[key];

      // Check if there are selected options
      if (selectedOptions && selectedOptions.length > 0) {
        // Join options into a string or keep them as an array
        acc[key] = selectedOptions.join(","); // Change to an array if needed
      }
      return acc;
    }, {}),
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
    setSearchQuery("");
    setIsFiltersApplied(false);
    setAppliedFilters({});
    setSelectedFilter("Date");
    setSelectedMonth(currentMonth + 1);
    setSelectedYear(currentYear);
  };

  useEffect(() => {
    setSelectedOption(toggleData?.[0]?.title);
  }, []);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data]);

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
      <>
        <TopMenu
          {...{
            setDrawerFilterOpen,
            selectedMonth,
            setSelectedMonth,
            selectedYear,
            setSelectedYear,
            selectedOption,
            handleToggle,
            filterApplied: isFiltersApplied,
            toggleData,
            searchQuery,
            setSearchQuery,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            selectedFacility,
            setSelectedFacility,
          }}
          heading={"Stationary Combustion"}
        />
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <TableDocument
            {...{
              data,
              totalPages,
              headers,
              page,
              handleChangePage,
              columnWidth,
              isShortContent,
              tableContainerRef,
            }}
          />
          {/* {drawerFilterOpen && (
              <FilterDrawer
                {...{
                  renderSelectedFilter,
                  drawerFilterOpen,
                  setDrawerFilterOpen,
                  handleApplyFilters,
                  handleFilterDrawer,
                  setSelectedFilter,
                  handleResetFilters,
                  selectedFilter,
                  filters,
                  appliedFilters,
                  selectedFields,
                  setSelectedFields,
                }}
              />
            )} */}
        </Box>
      </>
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default Main;
